// Shared chart theme for consistent, modern-looking Plotly charts
// Based on the Movement app color system

export const COLORS = [
  '#2849d6',  // blue (primary)
  '#36B2A4',  // green
  '#ec4899',  // pink
  '#e69900',  // orange
  '#8b5cf6',  // violet
  '#06b6d4',  // cyan
  '#f43f5e',  // rose
  '#84cc16',  // lime
  '#6366f1',  // indigo
  '#14b8a6',  // teal
]

export const FONT_FAMILY = 'system-ui, -apple-system, "Segoe UI", sans-serif'

export const baseLayout = {
  autosize: true,
  font: {
    family: FONT_FAMILY,
    color: '#334155',
    size: 13,
  },
  plot_bgcolor: '#ffffff',
  paper_bgcolor: '#ffffff',
  hovermode: 'x unified',
  hoverlabel: {
    bgcolor: '#1e293b',
    font: { color: '#ffffff', family: FONT_FAMILY, size: 13 },
    bordercolor: 'transparent',
  },
  legend: {
    orientation: 'h',
    yanchor: 'bottom',
    y: 1.04,
    xanchor: 'right',
    x: 1,
    font: { size: 12, color: '#64748b' },
    bgcolor: 'transparent',
    borderwidth: 0,
  },
  margin: { t: 24, r: 16, b: 44, l: 52 },
  xaxis: {
    gridcolor: '#f1f5f9',
    linecolor: '#e2e8f0',
    linewidth: 1,
    tickfont: { size: 11, color: '#94a3b8' },
    zeroline: false,
  },
  yaxis: {
    gridcolor: '#f1f5f9',
    linecolor: '#e2e8f0',
    linewidth: 1,
    tickfont: { size: 11, color: '#94a3b8' },
    zeroline: false,
  },
}

export const baseConfig = {
  displayModeBar: false,
  responsive: true,
  displaylogo: false,
}

// Deep merge layout objects (2 levels deep is sufficient for Plotly)
export function mergeLayout(overrides = {}) {
  const result = { ...baseLayout }
  for (const key of Object.keys(overrides)) {
    if (overrides[key] && typeof overrides[key] === 'object' && !Array.isArray(overrides[key]) && baseLayout[key] && typeof baseLayout[key] === 'object') {
      result[key] = { ...baseLayout[key], ...overrides[key] }
    } else {
      result[key] = overrides[key]
    }
  }
  return result
}

export function mergeConfig(overrides = {}) {
  return { ...baseConfig, ...overrides }
}
